module.exports = __webpack_public_path__ + "img/bleach-digital1.6dfed0b2.png";